import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import http from "../http";

const initialState = {
    data: null,
    loading: false,
    currentRoute:null,
    currentLineDetail:null,
}

export const fetchLine = createAsyncThunk('line', async () => {
    const response = await http.post("/v1/line")
    return response.data
})

const slice = createSlice({
    name: 'line',
    initialState,
    reducers: {
        SetRoute(state, action) {
            console.log(action.payload)
            state.currentRoute = action.payload;
        },
        UpdateCurrentLine(state, action) {
            state.currentLineDetail = action.payload;
        },

    },
    extraReducers: builder => {
        builder
            .addCase(fetchLine.pending, (state, action) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchLine.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.isSuccess == 1) {
                    state.data = action.payload.item;
                }
                else {
                    state.data = null;
                }

            })
            .addCase(fetchLine.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
})

export const { SetRoute,UpdateCurrentLine } = slice.actions

export default slice.reducer